unable to read source [project]/nextapp/node_modules/agent-base/src/helpers.ts